import axios from 'axios';
import { AuthContextValue } from '@/contexts/auth';
import { API_PREFIX } from '@/constants';
import { SOP } from "../constants";

export const querySOPDetail = async (id: SOP['id'], auth: AuthContextValue) => {
  const res = await axios.get<SOP>(`${API_PREFIX.WEB}/sop/task/detail/${id}`, {
    params: { ...auth }
  });
  if (res && res.data) {
    return res.data;
  }
  // return {
  //   id: 1,
  //   sopName: '这里是管理端配置的群SOP名称',
  //   scene: '客户旅程名称-节点名称',
  //   executeTime: '2021-10-09 10:00:00',
  //   sopSendType: SOPSendType.DAY,
  //   totalAmount: 200,
  //   entityType: SOPType.CUSTOMER_SOP,
  //   messageContent: [
  //     { type: MessageType.TEXT, content: { text: '亲，您浏览这个宝贝许久了，刚好我们今天有一个非常优惠的活动，特松您一份大礼，扫码领取专属优惠，快去下单吧，早早把宝贝买回家。' } },
  //     { type: MessageType.IMAGE, content: { picUrl: 'https://qa-pcrm.shuyun.com/pcrm/202110/e2f5f56627cbabf6e6790fe70503cefe/135426_23548_刮刮乐背景图.jpg' } },
  //     {
  //       type: MessageType.LINK, content: {
  //         desc: '10月特惠合集，打开有大惊喜哟！快来吧。10月特惠合集，打开有大惊喜哟！快来吧。',
  //         picUrl: 'https://qa-pcrm.shuyun.com/pcrm/202110/e2f5f56627cbabf6e6790fe70503cefe/164920_73586_带娃.jpeg',
  //         title: '我是活动内容，不进来看看怎么知道有没有喜欢的？手慢了都让别人抢走啦！我是活动内容，不进来看看怎么知道有没有喜欢的？手慢了都让别人抢走啦！',
  //         url: 'http://www.metaversed.top/'
  //       }
  //     }
  //   ],
  //   hasSend: false,
  //   executionResult: {
  //     status: SOPStatus.PENDING,
  //     sendType: SOPSendType.DAY,
  //     hasSendAmount: 200,
  //     successAmount: 199,
  //     failureAmount: 1,
  //   }
  // } as SOP;
}

export const markDailyMessageSend = async (id: SOP['id'], auth: AuthContextValue) => {
  const res = await axios.post<boolean>(`${API_PREFIX.WEB}/sop/task/rapid/send/${id}`, { ...auth });
  return res?.data;
}

export const sendWeeklyMessage = async (id: SOP['id'], auth: AuthContextValue) => {
  const res = await axios.post<boolean>(`${API_PREFIX.WEB}/sop/task/customer/send`, {
    ...auth,
    staffTaskId: id
  });
  return res?.data;
}

export const markSOPTaskFinish = async (id: SOP['id'], auth: AuthContextValue) => {
  const res = await axios.post<boolean>(`${API_PREFIX.WEB}/sop/task/mark/complete/${id}`, { ...auth });
  return res?.data;
}
